<template lang="pug">
    .property-value(v-if="!value")
        label {{ label }}
        span.gray {{ $t('Undefined') }}
    .property-value(v-else-if="type === 'unit'")
        label {{ label }}
        span.value {{ value }}
            span.unit {{ unit }}
    //- .property-value(v-else-if="type === 'color'")
    //-     label {{ label }}
    //-     span.value {{ colorName }}
    .property-value(v-else-if="type === 'date'")
        label {{ label }}
        span.value {{ dateValue }}
    .property-value(v-else-if="type === 'upload'")
        label {{ label }}
        el-tooltip(
            v-if="fileSignedUrl && isImage"
            placement="right"
            effect="dark"
            :open-delay="150"
        )
            template(slot="content")
                img.preview-img(:src="fileSignedUrl" width="250" height="250")
            a.file-link(
                :href="fileSignedUrl"
                @click.prevent="downloadFile"
            )
                i.el-icon-fa-file-image.far
                span.file-name(v-if="fileName") {{ fileName }}
        el-tooltip(
            v-else-if="fileSignedUrl"
            effect="dark"
            :content="fileName || $t('Download file')"
            placement="right"
        )
            a.file-link(
                :href="fileSignedUrl"
                @click.prevent="downloadFile"
            )
                i.el-icon-fa-file.far
                span.file-name(v-if="fileName") {{ fileName }}
        //- Fallback für ältere Bestellungen ohne signierte URL
        span.file-fallback(v-else-if="fileName || fileId")
            i.el-icon-fa-file.far
            span.file-id(v-if="fileName") {{ fileName }}
            span.file-id(v-else) {{ $t('File') }} #{{ fileId }}
        span.gray(v-else) {{ $t('No file') }}
    .property-value(v-else)
        label {{ label }}
        span.value(v-html="value")
</template>

<i18n>
{
    "de": {
        "Undefined": "Nicht definiert",
        "Download file": "Datei herunterladen",
        "No file": "Keine Datei",
        "File": "Datei"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { timestamp2date } from '@/filters';

import PropertyPivotValues from '@/extensions/shop/components/Products/PropertyPivotValues';

export default {
    name: 'PropertyValue',
    extends: PropertyPivotValues,
    props: {
        property: {
            type: Object,
            required: true,
        },
        valueOptions: {
            type: undefined,
            required: false,
        }
    },
    computed: {
        value() {
            return _.get(this.property, `valueOption.${this.field}`)
                || _.get(this.property, `value.${this.field}`)
        },
        valueAlt() {
            return _.get(this.property, `valueOption.${this.fieldAlt}`)
                || _.get(this.property, `value.${this.fieldAlt}`)
        },
        dateValue() {
            const value = _.get(this.property, `valueOption.${this.field}`)
                || _.get(this.property, `value.${this.field}`)

            const date = value !== null ? timestamp2date(value, this.dateformat) : null
            return date
        },
        fileSignedUrl() {
            return _.get(this.property, 'valueOption.file_signed_url')
                || _.get(this.property, 'value.file_signed_url')
        },
        fileMime() {
            return _.get(this.property, 'valueOption.file_mime')
                || _.get(this.property, 'value.file_mime')
        },
        isImage() {
            const mime = this.fileMime
            return !!mime && mime.startsWith('image/')
        },
        fileId() {
            return _.get(this.property, 'valueOption.text')
                || _.get(this.property, 'value.text')
        },
        fileName() {
            return _.get(this.property, 'valueOption.file_name')
                || _.get(this.property, 'value.file_name')
        },
    },
    methods: {
        async downloadFile() {
            if (!this.fileSignedUrl) return

            try {
                // Datei als Blob laden, um Cross-Origin-Download-Restriktionen zu umgehen
                const response = await fetch(this.fileSignedUrl)
                const blob = await response.blob()

                const objectUrl = URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = objectUrl
                link.download = this.fileName || 'download'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(objectUrl)
            } catch (error) {
                // Fallback: in neuem Tab öffnen
                window.open(this.fileSignedUrl, '_blank')
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.property-value
    label
        font-style: italic
        &:after
            content: ': '
    span.value
        white-space: pre-wrap
    span.unit:before
        content: ' '
    .gray
        color: lighten($color-grey-text, 10%)
        font-style: italic
    .file-link
        display: inline-flex
        align-items: center
        gap: 4px
        cursor: pointer
        color: $--color-primary
        text-decoration: none
        i
            font-size: 1.1em
        .file-name
            font-size: 0.9em
        &:hover
            color: darken($--color-primary, 10%)
    .file-fallback
        display: inline-flex
        align-items: center
        gap: 4px
        cursor: default
        color: $color-grey-text
        i
            font-size: 1.1em
        .file-id
            font-size: 0.85em

.preview-img
    background-image: url(https://cdn.cityoffer.online/admin-ui/tile.jpg)
    background-repeat: repeat
    background-size: auto
    width: 100%
    height: 100%
    max-width: 250px
    max-height: 250px
    object-fit: contain
</style>
